import {
  getDataAnalyticsApi,
  getSearchedDataAnalyticsApi,
} from '../api/andrologyApi';
import { fetchEmbryologyDataAnalyticsApi } from '../api/embryologyApi';

export const FETCH_ANALYTICS_REQUEST = 'FETCH_ANALYTICS_REQUEST';
export const FETCH_ANALYTICS_SUCCESS = 'FETCH_ANALYTICS_SUCCESS';
export const FETCH_ANALYTICS_FAILURE = 'FETCH_ANALYTICS_FAILURE';
export const SET_ANALYTICS_PAGE = 'SET_ANALYTICS_PAGE';
export const SET_ANALYTICS_PAGE_SIZE = 'SET_ANALYTICS_PAGE_SIZE';

export const fetchDataAnalytics =
  (page, pageSize, reportType) => async (dispatch) => {
    dispatch({ type: FETCH_ANALYTICS_REQUEST });

    try {
      const response = await getDataAnalyticsApi({
        page,
        pageSize,
        reportType,
      });
      console.log('response', response);

      dispatch({
        type: FETCH_ANALYTICS_SUCCESS,
        payload: {
          data: response.data.payload.patients,
          totalData: response.data.payload.totalRecords,
        },
      });
    } catch (error) {
      dispatch({
        type: FETCH_ANALYTICS_FAILURE,
        payload: error.message,
      });
    }
  };

export const fetchSearchedDataAnalytics =
  (
    page,
    pageSize,
    searchValue,
    searchByPatientId,
    searchByName,
    fromDate,
    toDate,
    reportType,
  ) =>
  async (dispatch) => {
    dispatch({ type: FETCH_ANALYTICS_REQUEST });
    try {
      const response = await getSearchedDataAnalyticsApi({
        page,
        pageSize,
        searchValue,
        searchByPatientId,
        searchByName,
        fromDate,
        toDate,
        reportType,
      });
      dispatch({
        type: FETCH_ANALYTICS_SUCCESS,
        payload: {
          data: response.data.payload.patients,
          totalData: response.data.payload.totalRecords,
        },
      });
    } catch (error) {
      dispatch({
        type: FETCH_ANALYTICS_FAILURE,
        payload: error.message,
      });
    }
  };

export const fetchEmbryologyDataAnalytics =
  (
    page,
    pageSize,
    searchValue,
    searchByPatientId,
    searchByName,
    fromDate,
    toDate,
    reportType,
  ) =>
  async (dispatch) => {
    dispatch({ type: FETCH_ANALYTICS_REQUEST });
    console.log(searchByPatientId, searchByName);
    try {
      const response = await fetchEmbryologyDataAnalyticsApi({
        page,
        pageSize,
        searchValue,
        searchByPatientId,
        searchByName,
        fromDate,
        toDate,
        reportType,
      });
      dispatch({
        type: FETCH_ANALYTICS_SUCCESS,
        payload: {
          data: response.data.payload.patients,
          totalData: response.data.payload.totalRecords,
        },
      });
    } catch (error) {
      dispatch({
        type: FETCH_ANALYTICS_FAILURE,
        payload: error.message,
      });
    }
  };

export const setDataAnalyticsPage = (page) => ({
  type: SET_ANALYTICS_PAGE,
  payload: page,
});

export const setDataAnalyticsPageSize = (pageSize) => ({
  type: SET_ANALYTICS_PAGE_SIZE,
  payload: pageSize,
});
